// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__b59Aw","header":"styles_header__5SW4N","footer":"styles_footer__B332Y","form":"styles_form__6zW8G","choose_all":"styles_choose_all__T5BNx"};